import { render, staticRenderFns } from "./SkipDialog.vue?vue&type=template&id=0dcb5a31&scoped=true&"
import script from "./SkipDialog.vue?vue&type=script&lang=js&"
export * from "./SkipDialog.vue?vue&type=script&lang=js&"
import style0 from "./SkipDialog.vue?vue&type=style&index=0&id=0dcb5a31&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb5a31",
  null
  
)

export default component.exports